import { type FC, type ReactNode } from "react";

import { Popover } from "../../PopoverV2";
import { type ColumnType, isPreviewableColumnType } from "../validation/parseColumnType";

export const MaybeWrapInColumnReadonlyPopover: FC<{
	columnType: ColumnType | undefined;
	columnReadonly: boolean | undefined;
	renderAsRowDetail: boolean | undefined;
	value: ReactNode;
}> = ({ columnType, columnReadonly, renderAsRowDetail, value }) => {
	if (renderAsRowDetail && columnType === "Table") {
		// No popover if we are rendering a table as row detail. This would render the popover OVER
		// the table, which makes no sense from a UI perspective.
		return value;
	} else if (!columnReadonly || (!renderAsRowDetail && isPreviewableColumnType(columnType))) {
		// Do not render popover if column is not readonly, or if it's one of the "details" column
		// types like subtable or multi-line string.
		return value;
	}

	const readonlyPopoverContents = (
		<div className="flex w-48 flex-col space-y-2">
			<h3 className="text-sm">Readonly column</h3>
			<div>Values of a readonly column cannot be edited directly.</div>
		</div>
	);

	return (
		<div className="group/table-cell-value relative text-left">
			<Popover.Root open>
				<Popover.Trigger asChild>{value}</Popover.Trigger>
				<div className="invisible group-focus-within/table-cell-value:visible">
					<Popover.Content>{readonlyPopoverContents}</Popover.Content>
				</div>
			</Popover.Root>
		</div>
	);
};
